import React, { useState, useEffect } from "react";
import weightliftingIcon from "../images/Weightlifting.png";
import privateTrainingIcon from "../images/PrivateTraining.png";
import buildMuscleIcon from "../images/BuildMuscle.png";
import serviceBackground from "../images/servicebackground.png";

export default function ServicesSection() {
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Auto-rotate carousel for mobile screens
  useEffect(() => {
    if (isSmallMobile || isMobile || isMediumMobile || isLargePhone || (isTablet && windowWidth <= 991)) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % 3); // 3 cards total
      }, 5000); // Change every 5 seconds

      return () => clearInterval(interval);
    }
  }, [windowWidth <= 1024]);

  const isSmallMobile = windowWidth >= 320 && windowWidth <= 480;
  const isMobile = windowWidth <= 480;
  const isMediumMobile = windowWidth >= 481 && windowWidth <= 767;
  const isLargePhone = windowWidth >= 768 && windowWidth <= 991;
  const isTablet = windowWidth >= 768 && windowWidth <= 1024;
  const isTinyMobile = windowWidth < 320;
  const iconStyle = {
    width: "64px",
    height: "64px",
    marginBottom: "24px",
    filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.2))",
    transition: "transform 0.3s ease",
  };

  const cardBaseStyle = {
    background: "#333",
    color: "#fff",
    padding: "40px 30px",
    width: "280px",
    textAlign: "center",
    boxShadow: "0 20px 40px rgba(0,0,0,0.3), 0 8px 16px rgba(0,0,0,0.15)",
    fontFamily: "Inter, sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    position: "relative",
    transition: "all 0.3s ease",
    cursor: "pointer",
    overflow: "hidden",
    borderRadius: "25px",
    border: "1px solid rgba(255,255,255,0.1)",
  };

  // Carousel data
  const carouselCards = [
    {
      icon: weightliftingIcon,
      title: "Weight Lifting",
      description: "Professional weight training programs designed to build strength and muscle with expert guidance and safety"
    },
    {
      icon: privateTrainingIcon,
      title: "Private Training", 
      description: "One-on-one personalized training sessions tailored to your specific goals and fitness level with dedicated professional support"
    },
    {
      icon: buildMuscleIcon,
      title: "Build Muscle",
      description: "Comprehensive muscle building programs with proper nutrition guidance and progressive training"
    }
  ];

  const containerStyle = {
    display: "flex",
    gap: "30px",
    justifyContent: "center",
    alignItems: "flex-start",
    backgroundImage: `url(${serviceBackground})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    padding: "100px 20px",
  };

  const titleStyle = {
    margin: "16px 0 24px",
    fontSize: "20px",
    fontWeight: "600",
    letterSpacing: "0.5px",
  };

  const textStyle = {
    fontSize: "14px",
    margin: "6px 0",
    color: "#ccc",
    lineHeight: "1.5",
    fontWeight: "400",
  };

  // Common hover handlers
  const handleMouseEnter = (e, isCenter) => {
    e.currentTarget.style.transform = isCenter ? 'scale(1.05) translateY(-8px)' : 'translateY(-8px)';
    e.currentTarget.style.boxShadow = '0 30px 60px rgba(0,0,0,0.4), 0 12px 24px rgba(0,0,0,0.2)';
    e.currentTarget.querySelector('img').style.transform = 'scale(1.1)';
  };

  const handleMouseLeave = (e, isCenter) => {
    e.currentTarget.style.transform = isCenter ? 'scale(1.05) translateY(0)' : 'translateY(0)';
    e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.3), 0 8px 16px rgba(0,0,0,0.15)';
    e.currentTarget.querySelector('img').style.transform = 'scale(1)';
  };

  return (
    <section
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: (isSmallMobile || isMobile || isMediumMobile || isLargePhone || (isTablet && windowWidth <= 991)) ? "0" : isTablet ? "40px" : "32px", // Enhanced gap for larger tablets
        margin: "0px 0",
        backgroundImage: `url(${serviceBackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        padding: isSmallMobile ? "25px 8px" : 
                 isMobile ? "40px 15px" : 
                 isMediumMobile ? "50px 20px" : 
                 isLargePhone ? "60px 25px" : 
                 isTablet ? "70px 30px" : 
                 "60px 0",
        fontFamily: "Arial, sans-serif",
        flexDirection: "row", // Keep row for carousel
        overflow: (isSmallMobile || isMobile || isMediumMobile || isLargePhone || (isTablet && windowWidth <= 991)) ? "hidden" : "visible", // Hide overflow for carousel on smaller tablets
        position: "relative",
      }}
    >
      {(isSmallMobile || isMobile || isMediumMobile || isLargePhone || (isTablet && windowWidth <= 991)) ? (
        // Small Mobile, Mobile, Medium Mobile, Large Phone & Small Tablet Carousel
        <div style={{ 
          width: isSmallMobile ? "85%" : 
                isMobile ? "75%" : 
                isMediumMobile ? "80%" : 
                isLargePhone ? "65%" : 
                (isTablet && windowWidth <= 991) ? "70%" : 
                "75%", 
          position: "relative" 
        }}>
          {/* Carousel Container */}
          <div style={{
            display: "flex",
            width: "100%",
            transition: "transform 0.5s ease-in-out",
            transform: `translateX(-${currentIndex * 100}%)`,
          }}>
            {carouselCards.map((card, index) => (
              <div
                key={index}
                style={{
                  background: "#333",
                  color: "#fff",
                  borderRadius: isSmallMobile ? "20px" : 
                               isMobile ? "24px" : 
                               isMediumMobile ? "28px" : 
                               isLargePhone ? "32px" : 
                               (isTablet && windowWidth <= 991) ? "36px" : 
                               "32px",
                  padding: isSmallMobile ? "18px 14px" : 
                           isMobile ? "20px 16px" : 
                           isMediumMobile ? "28px 24px" : 
                           isLargePhone ? "32px 28px" : 
                           (isTablet && windowWidth <= 991) ? "40px 32px" : 
                           "24px 20px",
                  width: "100%",
                  minWidth: "100%", // Full width for each carousel item
                  textAlign: "center",
                  fontFamily: "Arial, sans-serif",
                  boxShadow: "0 4px 32px rgba(0,0,0,0.2)",
                  position: "relative",
                  overflow: "hidden",
                  minHeight: isSmallMobile ? "220px" : 
                             isMobile ? "240px" : 
                             isMediumMobile ? "300px" : 
                             isLargePhone ? "350px" : 
                             (isTablet && windowWidth <= 991) ? "400px" : 
                             "260px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 10px", // Small margin between cards
                }}
              >
                <div
                  className="shine"
                  style={{
                    content: "''",
                    position: "absolute",
                    top: 0,
                    left: "-75%",
                    width: "50%",
                    height: "100%",
                    background: "linear-gradient(120deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0) 100%)",
                    transform: "skewX(-20deg)",
                    pointerEvents: "none",
                    zIndex: 2
                  }}
                />
                <img 
                  src={card.icon} 
                  alt={card.title} 
                  style={{ 
                    width: isSmallMobile ? 45 : 
                           isMobile ? 50 : 
                           isMediumMobile ? 70 : 
                           isLargePhone ? 80 : 
                           (isTablet && windowWidth <= 991) ? 90 : 
                           60, 
                    height: isSmallMobile ? 40 : 
                            isMobile ? 45 : 
                            isMediumMobile ? 64 : 
                            isLargePhone ? 72 : 
                            (isTablet && windowWidth <= 991) ? 82 : 
                            55, 
                    marginBottom: isSmallMobile ? 10 : 
                                  isMobile ? 12 : 
                                  isMediumMobile ? 16 : 
                                  isLargePhone ? 20 : 
                                  (isTablet && windowWidth <= 991) ? 24 : 
                                  14 
                  }} 
                />
                <h3 style={{ 
                  fontSize: isSmallMobile ? "1.0rem" : 
                            isMobile ? "1.1rem" : 
                            isMediumMobile ? "1.4rem" : 
                            isLargePhone ? "1.6rem" : 
                            (isTablet && windowWidth <= 991) ? "1.8rem" : 
                            "1.3rem", 
                  fontWeight: "bold", 
                  marginBottom: isSmallMobile ? 5 : 
                                isMobile ? 6 : 
                                isMediumMobile ? 8 : 
                                isLargePhone ? 10 : 
                                (isTablet && windowWidth <= 991) ? 12 : 
                                7, 
                  letterSpacing: "1px" 
                }}>{card.title}</h3>
                <hr style={{ 
                  border: "none", 
                  borderTop: "2px solid #888", 
                  margin: isSmallMobile ? "10px auto" : 
                          isMobile ? "12px auto" : 
                          isMediumMobile ? "16px auto" : 
                          isLargePhone ? "18px auto" : 
                          (isTablet && windowWidth <= 991) ? "20px auto" : 
                          "14px auto", 
                  width: "80%", 
                  display: "block" 
                }} />
                <p style={{ 
                  color: "#eee", 
                  fontSize: isSmallMobile ? "0.75rem" : 
                            isMobile ? "0.8rem" : 
                            isMediumMobile ? "1rem" : 
                            isLargePhone ? "1.1rem" : 
                            (isTablet && windowWidth <= 991) ? "1.2rem" : 
                            "0.9rem", 
                  margin: "8px 0", 
                  padding: isSmallMobile ? "0 6px" : 
                           isMobile ? "0 8px" : 
                           isMediumMobile ? "0 12px" : 
                           isLargePhone ? "0 16px" : 
                           (isTablet && windowWidth <= 991) ? "0 20px" : 
                           "0 10px", 
                  lineHeight: 1.7 
                }}>
                  {card.description}
                </p>
              </div>
            ))}
          </div>
          
          {/* Carousel Indicators */}
          <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            marginTop: isSmallMobile ? "18px" : 
                       isMobile ? "20px" : 
                       isMediumMobile ? "25px" : 
                       isLargePhone ? "30px" : 
                       (isTablet && windowWidth <= 991) ? "35px" : 
                       "20px",
          }}>
            {carouselCards.map((_, index) => (
              <div
                key={index}
                onClick={() => setCurrentIndex(index)}
                style={{
                  width: isSmallMobile ? "8px" : 
                         isMobile ? "10px" : 
                         isMediumMobile ? "12px" : 
                         isLargePhone ? "14px" : 
                         (isTablet && windowWidth <= 991) ? "16px" : 
                         "10px",
                  height: isSmallMobile ? "8px" : 
                          isMobile ? "10px" : 
                          isMediumMobile ? "12px" : 
                          isLargePhone ? "14px" : 
                          (isTablet && windowWidth <= 991) ? "16px" : 
                          "10px",
                  borderRadius: "50%",
                  backgroundColor: currentIndex === index ? "#fff" : "rgba(255,255,255,0.5)",
                  cursor: "pointer",
                  transition: "background-color 0.3s ease",
                  border: "1px solid rgba(255,255,255,0.3)",
                }}
              />
            ))}
          </div>
        </div>
      ) : (
        // Desktop Cards (Original Layout)
        <>
          {/* Left Card */}
          <div
        style={{
          background: "#333",
          color: "#fff",
          borderRadius: isSmallMobile ? "20px" : 
                        isMobile ? "24px" : 
                        isTablet ? "40px" : 
                        "48px",
          padding: isSmallMobile ? "18px 14px" : 
                   isMobile ? "20px 16px" : 
                   isTablet ? "36px 28px" : 
                   "32px 24px",
          width: isSmallMobile ? "260px" : 
                 isMobile ? "280px" : 
                 isTablet ? "320px" : 
                 "350px",
          textAlign: "center",
          fontFamily: "Arial, sans-serif",
          boxShadow: "0 4px 32px rgba(0,0,0,0.2)",
          transform: "rotate(0deg)",
          marginTop: isMobile ? "0" : isTablet ? "12px" : "16px",
          position: "relative",
          overflow: "hidden",
          cursor: "pointer",
          minHeight: isMobile ? (isSmallMobile ? "200px" : "220px") : 
                     isTablet ? "280px" : 
                     "250px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center"
        }}
        onMouseEnter={e => {
          const shine = e.currentTarget.querySelector('.shine');
          if (shine) {
            shine.style.animation = 'shine-move 0.8s forwards';
          }
        }}
        onMouseLeave={e => {
          const shine = e.currentTarget.querySelector('.shine');
          if (shine) {
            shine.style.animation = 'none';
          }
        }}
      >
        <div
          className="shine"
          style={{
            content: "''",
            position: "absolute",
            top: 0,
            left: "-75%",
            width: "50%",
            height: "100%",
            background: "linear-gradient(120deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0) 100%)",
            transform: "skewX(-20deg)",
            pointerEvents: "none",
            zIndex: 2
          }}
        />
        <img src={weightliftingIcon} alt="WeightLifting" style={{ 
          width: isSmallMobile ? 45 : 
                 isMobile ? 50 : 
                 isTablet ? 75 : 
                 70, 
          height: isSmallMobile ? 40 : 
                  isMobile ? 45 : 
                  isTablet ? 68 : 
                  64, 
          marginBottom: isSmallMobile ? 10 : 
                        isMobile ? 12 : 
                        isTablet ? 18 : 
                        16 
        }} />
        <h3 style={{ 
          fontSize: isSmallMobile ? "1.0rem" : 
                    isMobile ? "1.1rem" : 
                    isTablet ? "1.4rem" : 
                    "1.5rem", 
          fontWeight: "bold", 
          marginBottom: isSmallMobile ? 5 : 
                        isMobile ? 6 : 
                        isTablet ? 9 : 
                        8, 
          letterSpacing: "1px" 
        }}>Weight Lifting</h3>
        <hr style={{ 
          border: "none", 
          borderTop: "2px solid #888", 
          margin: isSmallMobile ? "10px auto" : 
                  isMobile ? "12px auto" : 
                  isTablet ? "18px auto" : 
                  "16px auto", 
          width: "80%", 
          display: "block" 
        }} />
        <p style={{ 
          color: "#eee", 
          fontSize: isSmallMobile ? "0.75rem" : 
                    isMobile ? "0.8rem" : 
                    isTablet ? "1.1rem" : 
                    "1rem", 
          margin: "8px 0", 
          padding: isSmallMobile ? "0 6px" : 
                   isMobile ? "0 8px" : 
                   isTablet ? "0 14px" : 
                   "0 12px", 
          lineHeight: 1.7 
        }}>
        Professional weight training programs
          designed to build strength and muscle
          with expert guidance and safety
        </p>
      </div>
      {/* Center Card */}
      <div
        style={{
          background: "#333",
          color: "#fff",
          borderRadius: isMobile ? (isSmallMobile ? "24px" : "32px") : 
                        isTablet ? "40px" : 
                        "48px",
          padding: isMobile ? (isSmallMobile ? "20px 16px" : "24px 20px") : 
                   isTablet ? "36px 28px" : 
                   "32px 24px",
          width: isMobile ? (isSmallMobile ? "280px" : "320px") : 
                 isTablet ? "320px" : 
                 "350px",
          textAlign: "center",
          fontFamily: "Arial, sans-serif",
          boxShadow: "0 4px 32px rgba(0,0,0,0.2)",
          transform: "rotate(0deg)",
          zIndex: 1,
          position: "relative",
          overflow: "hidden",
          cursor: "pointer",
          minHeight: isMobile ? (isSmallMobile ? "240px" : "260px") : 
                     isTablet ? "320px" : 
                     "300px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center"
        }}
        onMouseEnter={e => {
          const shine = e.currentTarget.querySelector('.shine');
          if (shine) {
            shine.style.animation = 'shine-move 0.8s forwards';
          }
        }}
        onMouseLeave={e => {
          const shine = e.currentTarget.querySelector('.shine');
          if (shine) {
            shine.style.animation = 'none';
          }
        }}
      >
        <div
          className="shine"
          style={{
            content: "''",
            position: "absolute",
            top: 0,
            left: "-75%",
            width: "50%",
            height: "100%",
            background: "linear-gradient(120deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0) 100%)",
            transform: "skewX(-20deg)",
            pointerEvents: "none",
            zIndex: 2
          }}
        />
        <img src={privateTrainingIcon} alt="Private Training" style={{ 
          width: isMobile ? (isSmallMobile ? 50 : 60) : isTablet ? 75 : 70, 
          height: isMobile ? (isSmallMobile ? 45 : 55) : isTablet ? 68 : 64, 
          marginBottom: isMobile ? (isSmallMobile ? 12 : 14) : isTablet ? 18 : 16 
        }} />
        <h3 style={{ 
          fontSize: isMobile ? (isSmallMobile ? "1.1rem" : "1.3rem") : isTablet ? "1.4rem" : "1.5rem", 
          fontWeight: "bold", 
          marginBottom: isMobile ? (isSmallMobile ? 6 : 7) : isTablet ? 9 : 8, 
          letterSpacing: "1px" 
        }}>Private Training</h3>
        <hr style={{ 
          border: "none", 
          borderTop: "2px solid #888", 
          margin: isMobile ? (isSmallMobile ? "12px auto" : "14px auto") : isTablet ? "18px auto" : "16px auto", 
          width: "80%", 
          display: "block" 
        }} />
        <p style={{ 
          color: "#eee", 
          fontSize: isMobile ? (isSmallMobile ? "0.8rem" : "0.9rem") : isTablet ? "1.1rem" : "1rem", 
          margin: "8px 0", 
          padding: isMobile ? (isSmallMobile ? "0 8px" : "0 10px") : isTablet ? "0 14px" : "0 12px", 
          lineHeight: 1.7 
        }}>
        One-on-one personalized training
        sessions tailored to your specific goals and fitness level with dedicated professional support.
        </p>
      </div>
      {/* Right Card */}
      <div
        style={{
          background: "#333",
          color: "#fff",
          borderRadius: isMobile ? (isSmallMobile ? "24px" : "32px") : 
                        isTablet ? "40px" : 
                        "48px",
          padding: isMobile ? (isSmallMobile ? "20px 16px" : "24px 20px") : 
                   isTablet ? "36px 28px" : 
                   "32px 24px",
          width: isMobile ? (isSmallMobile ? "280px" : "320px") : 
                 isTablet ? "320px" : 
                 "350px",
          textAlign: "center",
          fontFamily: "Arial, sans-serif",
          boxShadow: "0 4px 32px rgba(0,0,0,0.2)",
          transform: "rotate(0deg)",
          marginTop: isMobile ? "0" : isTablet ? "12px" : "16px",
          position: "relative",
          overflow: "hidden",
          cursor: "pointer",
          minHeight: isMobile ? (isSmallMobile ? "200px" : "220px") : 
                     isTablet ? "280px" : 
                     "250px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center"
        }}
        onMouseEnter={e => {
          const shine = e.currentTarget.querySelector('.shine');
          if (shine) {
            shine.style.animation = 'shine-move 0.8s forwards';
          }
        }}
        onMouseLeave={e => {
          const shine = e.currentTarget.querySelector('.shine');
          if (shine) {
            shine.style.animation = 'none';
          }
        }}
      >
        <div
          className="shine"
          style={{
            content: "''",
            position: "absolute",
            top: 0,
            left: "-75%",
            width: "50%",
            height: "100%",
            background: "linear-gradient(120deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0) 100%)",
            transform: "skewX(-20deg)",
            pointerEvents: "none",
            zIndex: 2
          }}
        />
        <img src={buildMuscleIcon} alt="Build Muscle" style={{ 
          width: isMobile ? (isSmallMobile ? 50 : 60) : isTablet ? 75 : 70, 
          height: isMobile ? (isSmallMobile ? 45 : 55) : isTablet ? 68 : 64, 
          marginBottom: isMobile ? (isSmallMobile ? 12 : 14) : isTablet ? 18 : 16 
        }} />
        <h3 style={{ 
          fontSize: isMobile ? (isSmallMobile ? "1.1rem" : "1.3rem") : isTablet ? "1.4rem" : "1.5rem", 
          fontWeight: "bold", 
          marginBottom: isMobile ? (isSmallMobile ? 6 : 7) : isTablet ? 9 : 8, 
          letterSpacing: "1px" 
        }}>Build Muscle</h3>
        <hr style={{ 
          border: "none", 
          borderTop: "2px solid #888", 
          margin: isMobile ? (isSmallMobile ? "12px auto" : "14px auto") : isTablet ? "18px auto" : "16px auto", 
          width: "80%", 
          display: "block" 
        }} />
        <p style={{ 
          color: "#eee", 
          fontSize: isMobile ? (isSmallMobile ? "0.8rem" : "0.9rem") : isTablet ? "1.1rem" : "1rem", 
          margin: "8px 0", 
          padding: isMobile ? (isSmallMobile ? "0 8px" : "0 10px") : isTablet ? "0 14px" : "0 12px", 
          lineHeight: 1.7 
        }}>
        Comprehensive muscle building
        programs with proper nutrition
        guidance and progressive training.
        </p>
      </div>
        </>
      )}
      <style>{`
        @keyframes shine-move {
          0% { left: -75%; }
          100% { left: 125%; }
        }
      `}</style>
    </section>
  );
}
